/* RESPONSIBLE TEAM: team-inbox-management */
import Model, { attr, hasMany } from '@ember-data/model';

export default class CancellationQuestion extends Model {
  @attr() question;
  @attr('boolean') multiSelect;
  @attr('boolean') isFollowUp;
  @hasMany('cancellation-reason', { inverse: 'cancellationQuestion' }) cancellationReasons;
}
